import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../../store/actions/employeeActions';
import "react-datepicker/dist/react-datepicker.css";
import { XMarkIcon } from '@heroicons/react/20/solid'

const DeleteConfimationModal = ({
    modalOptions,
    deleteAgreement,
    closeModal,
}) => {
    const { open, message, agreement } = modalOptions

    if (!open) {
        return null;
    }

    return (
        <div class="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div class="block-header bg-primary-dark" style={{ padding: 20 }}>
                            <ul class="block-options">
                                <li>
                                    <button type="button" onClick={() => { closeModal() }}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 class="block-title">Delete Agreement</h3>
                        </div>
                    </div>
                    <div class="block-content">
                        <textarea
                            className="form-control"
                            type="text"
                            disabled
                            style={{ height: 400, resize: "none" }}
                            value={message || "Are you sure you want to delete this agreement?"}
                        />

                    </div>
                    <div class="block-content" style={{ padding: 20 }}>

                        <button class="btn btn-default pull-left" onClick={() => { closeModal() }}>Cancel</button>
                        <button class="btn btn-success pull-right" onClick={() => {
                            deleteAgreement(agreement, message ? true : false)
                        }}>Approve</button>

                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {

    return {
        modalOptions: state?.company?.adminDeleteModal || {}
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(ACTIONS.deleteAgreementModal(false)),
    deleteAgreement: (agreement, confirmation) => dispatch(ACTIONS.deleteAgreementData(agreement, confirmation))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteConfimationModal)